import createIcon from '../../createIcon';

/**
 * @component @name Man
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgN0gxMEM4LjkgNyA4IDcuOSA4IDlWMTVIMTBWMjJIMTRWMTVIMTZWOUMxNiA3LjkgMTUuMSA3IDE0IDdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIgNkMxMy4xMDQ2IDYgMTQgNS4xMDQ1NyAxNCA0QzE0IDIuODk1NDMgMTMuMTA0NiAyIDEyIDJDMTAuODk1NCAyIDEwIDIuODk1NDMgMTAgNEMxMCA1LjEwNDU3IDEwLjg5NTQgNiAxMiA2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Man = createIcon('Man', [
  [
    'path',
    { d: 'M14 7H10C8.9 7 8 7.9 8 9V15H10V22H14V15H16V9C16 7.9 15.1 7 14 7Z', key: 'rpu9sy' },
  ],
  [
    'path',
    {
      d: 'M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z',
      key: '1cb55s',
    },
  ],
]);

export default Man;
